import React from 'react'
import { Typography } from 'antd'

const { Text, Title } = Typography
class CardTitle extends React.PureComponent {

	render() {
		const { title, subtitle } = this.props
		return (
			<>
				<div className="card-custom-template p-6" align="center">
                    <Title level={1} className="color-white mb-0">
                        {title}
                    </Title>
                    <span className="color-orange">{subtitle}</span>
                </div>
			</>
		)
	}
}

export default CardTitle